module.exports = __webpack_public_path__ + "img/mc.75b10a2c.svg";